<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5 23.0001C18.299 23.0001 23 18.2991 23 12.5001C23 6.70113 18.299 2.00012 12.5 2.00012C6.70101 2.00012 2 6.70113 2 12.5001C2 18.2991 6.70101 23.0001 12.5 23.0001ZM18.4984 8.29525L13.4969 5.41965C12.8797 5.0648 12.1203 5.0648 11.5031 5.41965L6.50157 8.29525C6.19128 8.47364 6 8.80426 6 9.16218V15.5772C6 16.3284 6.42094 17.0163 7.08986 17.3581L12.0449 19.8905C12.3307 20.0365 12.6693 20.0365 12.9551 19.8905L17.9101 17.3581C18.5791 17.0163 19 16.3284 19 15.5772V9.16218C19 8.80426 18.8087 8.47364 18.4984 8.29525ZM12.5 7.15351L15.9037 9.11046L12.5 10.85L9.09625 9.11046L12.5 7.15351ZM13.5 12.585L17 10.7963V15.5772L13.5 17.3659V12.585ZM11.5 12.585V17.3659L8 15.5772V10.7963L11.5 12.585Z"
      fill="#999999"
    />
  </svg>
</template>
